import { ACTION_TYPES, useObrasDispatch, useObrasState } from "./obras-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IObraPagedRequest } from "models/request/obra-paged-request";
import { downloadFile } from "utils/download-file";

export const useObrasController = () => {
    const obrasDispatch = useObrasDispatch();
    const { obraPagedRequest } = useObrasState();

    async function exportObras(format: string) {
        const file = await MunicipalPortalAAppService.exportObras(obraPagedRequest, format);
        downloadFile(file);
    }

    async function onInit() {
        let request = { page: 0, pageSize: 10 } as IObraPagedRequest;

        obrasDispatch({ type: ACTION_TYPES.setObraPagedRequest, payload: request });
        obrasDispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listObras(request);
        await loadLookups();

        obrasDispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function loadLookups() {
        try {
            const [situacoes, funcoes, tipos, ultimaAtualizacao] = await Promise.all([
                MunicipalPortalAAppService.listSituacoesObra(),
                MunicipalPortalAAppService.listFuncoesObra(),
                MunicipalPortalAAppService.listTiposObra(),
                MunicipalPortalAAppService.getObrasUltimaAtualizacao()
            ]);
            obrasDispatch({ type: ACTION_TYPES.setSituacoes, payload: situacoes });
            obrasDispatch({ type: ACTION_TYPES.setFuncoes, payload: funcoes });
            obrasDispatch({ type: ACTION_TYPES.setTipos, payload: tipos });
            obrasDispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
        } catch (error) {
            console.log(error);
        }
    }

    async function listObras(request: IObraPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                obrasDispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            obrasDispatch({ type: ACTION_TYPES.setError, payload: null });

            const obras = await MunicipalPortalAAppService.listObras(request);

            obrasDispatch({ type: ACTION_TYPES.setObras, payload: obras });
        } catch (error) {
            console.log(error);
            obrasDispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar as obras. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                obrasDispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...obraPagedRequest };

        if (e.target.name === "select-situacao-id") {
            updated.idSituacaoObra = e.target.value;
        } else if (e.target.name === "select-funcao-id") {
            updated.idFuncaoObra = e.target.value;
        } else if (e.target.name === "select-tipo-id") {
            updated.idTipoObra = e.target.value;
        } else if (e.target.name === "date-field-inicio") {
            updated.dataInicio = e.target.value;
        } else if (e.target.name === "date-field-fim") {
            updated.dataFim = e.target.value;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listObras({ ...updated, page: 0 }, true))();
        }

        obrasDispatch({ type: ACTION_TYPES.setObraPagedRequest, payload: updated });
    };

    return { listObras, handleOnChange, onInit, exportObras };
}
